import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { LoadingPage } from "./pages";
import "./index.css";

import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <React.Suspense fallback={<LoadingPage />}>
      <App />
    </React.Suspense>
  </React.StrictMode>
);
